module.exports = __webpack_public_path__ + "img/4.1600e6c8.jpg";